import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_LoginHeader = _resolveComponent("LoginHeader")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_TwoFAPopup = _resolveComponent("TwoFAPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.getters.isLoggedIn)
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : (_openBlock(), _createBlock(_component_LoginHeader, {
          key: 1,
          onUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update()))
        })),
    _createElementVNode("main", null, [
      (_ctx.inited && _ctx.store.getters.isLoggedIn)
        ? (_openBlock(), _createBlock(_component_Sidebar, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.inited)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["content", {'logged': _ctx.store.getters.isLoggedIn}])
          }, [
            _createVNode(_component_router_view, {
              class: _normalizeClass({'updt': _ctx.updated})
            }, null, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_notifications, { class: "" })
    ]),
    _createVNode(_component_TwoFAPopup, {
      ref: (el) => _ctx.tfaPopup = el
    }, null, 512)
  ], 64))
}